<template>
    <div>
        <innerheader />
        <proposal />
    </div>
</template>

<script>
// @ is an alias to /src
import innerheader from "@/components/innerheader/innerheader.vue";
import proposal from "@/components/proposal/proposal-page.vue";

export default {
  name:' proposal',
  components: {
     innerheader,
     proposal
  }
}
</script>

<style scoped lang="scss">
@import '~@/assets/scss/components/proposal-page.scss';
</style>